import { firestore } from "@/services/firestore";
import { AutomationHistoryEntry } from "@/types/v2";
import { Unsubscribe } from "firebase/firestore";

/**
 * A card's automation-firing history lives at
 * shops/{shopId}/automations/history/cards/{cardId}/entries — see
 * functions-v2/src/repositories/automationHistory.ts (the write side, from
 * WEBV3-264) for the same path.
 */
export const automationHistoryRepository = {
  collectionPath: (shopId: string, cardId: string): string =>
    `shops/${shopId}/automations/history/cards/${cardId}/entries`,

  subscribeByCard: (
    shopId: string,
    cardId: string,
    callback: (entries: AutomationHistoryEntry[]) => void,
    limitResults: number = 25
  ): Unsubscribe => {
    return firestore.subscribeCollection<AutomationHistoryEntry>(
      automationHistoryRepository.collectionPath(shopId, cardId),
      callback,
      undefined,
      limitResults,
      "firedAt",
      "desc"
    );
  },
};
